module.exports = __webpack_public_path__ + "img/p12.b1f0dac4.svg";